import React from 'react';
import { NumericInput as NumericInputNew } from './NumericInput';
import { convertOldNumericInputProps } from './converter.old';
import type { OldNumericInputBaseType, OldNumericInputProps } from './converter.old';

export type NumericInputProps<TAllowEmpty extends boolean = false> = OldNumericInputProps<TAllowEmpty>;
export type NumericInputBaseType<TAllowEmpty extends boolean = false> = OldNumericInputBaseType<TAllowEmpty>;

function NumericInputInner<TAllowEmpty extends boolean = false>(
  props: NumericInputProps<TAllowEmpty>,
  ref: React.Ref<HTMLInputElement>,
) {
  return <NumericInputNew {...convertOldNumericInputProps(props)} ref={ref} />;
}

export const NumericInput = React.forwardRef(NumericInputInner) as <TAllowEmpty extends boolean = false>(
  props: NumericInputProps<TAllowEmpty> & { ref?: React.Ref<HTMLInputElement> },
) => JSX.Element;
